
<template>
    <footer class="footer footer__contact">
        <router-link :to="{ name: 'account' }" v-if="isAuthenticated">Account Settings</router-link>
        <p>Need tech support or have a suggestion?</p>
        <p>Contact the ACEM helpline on <a href="mailto:edmentalhealth@acem.org.au">edmentalhealth@acem.org.au</a></p>
    </footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters('Auth', ['isAuthenticated'])
    }
}
</script>
